import { acceptHMRUpdate, defineStore } from "pinia";
import {shallowRef} from "vue";
import {has as _has, get as _get} from 'lodash-es';
import {printCurrencyValue, sessionStorage_SearchAndRetrive} from "@/common-scripts/utilities";
import {useBookingStore} from "@/stores/booking";
import {useBookingStepperStore} from "@/stores/booking-stepper";
import {useDialogManagerStore} from "@/stores/dialog-manager";


export function defaultValues(){
	let matrix = {
		currency: 'EUR',
		lang: 'IT',
	};
	const result = Object.assign({}, matrix);

	return result;
}

export const useLocalizationStore = defineStore('localization', {
	state: () => ({
		currency: 'EUR',
		lang: 'IT',
		// countryCodes: shallowRef()
	}),
	getters: {
	},
	actions: {
	}
});

if(import.meta.hot){
	import.meta.hot.accept(acceptHMRUpdate(useLocalizationStore, import.meta.hot));
}